import { ICenter } from '@nkr/models/index';
import CenterReportsNav from './center-nav';
import ChainEndDeclineRatio from './chain-end-decline-ratio';
import NkrDonorReferralConversionRate from './nkr-donor-referral-conversion-rate';
import ChainEndOffers from './chain-end-offers';
import MissedMatchOffers from './missed-match-offers';
import LateDonorReviewsReport from './late-donor-reviews';
import CenterCLCScoresReport from './center-clc-scores';
import CenterCLCTargetedPairsReport from './center-clc-targeted-pairs';
import CenterCLCGuide from './center-clc-guide';
import RefrReport from './refr';
import CenterFiveStarSurveyReport from './center-five-star-survey';
import NetworkFiveStarSurveyReport from './network-five-star-survey';
import LateSerologies from './late-serologies';
import SerologyFinalXmBloodDraws from './serology-final-xm-blood-draws';
import SerologyBloodDraws from './serology-blood-draws';
import OnTimeKidneyPickupDetail from './on-time-kidney-pickup-detail';
import ColdIschemiaLateDetail from './cold-ischemia-lag-time';
import PreselectReversalDetail from './administration/preselect-reversal-detail';
import SurgicalDateDeclines from './administration/surgical-declines';
import OverallPerformance from './overall-performance';
import CenterCLCScoresDetailsReport from './center-clc-scores-details';
import PreSelectHistoryByCenterReport from './performance/pre-select-history-by-center';
import PreselectHistoryDetail from './performance/preselect-history-detail';
import CenterChainEndOffers from './center-chain-end-offers';
import DashboardSummary from './dash-board/summary'
import DashboardVolume from './dash-board/volume'
import ComparisonConversionReport from './comparison-conversion';
import ComparisonVolumeReport from './comparison-volume';
import WaitlistAudit from './waitlist-audit';
import { CprScoreAudit } from '@nkr/views/reports/cpr-score-audit';
import FcrScoreAudit from '@nkr/views/reports/fcr-score-audit';
import LateVxm from './late-vxm';
import LateFinalXm from './late-final-xm';
import RccapList from '../rccap/center/rccap-list';
import CenterNCSScoresReport from './center-ncs-scores';
import PatientDonors from './dash-board/patient-donors';
import DashPWLLabBilling from './dash-board/pwl/lab-billing'
import DashPWLJugBilling from './dash-board/pwl/jug-billing'
import Contacts from './dash-board/contacts';
import AllCenters from './all-centers'
import CenterSpecifc from './all-centers/center-specific';
import TransplantedPatients from './performance/transplanted-patients';
import Compliance from './compliance';
import DataComplianceIssuesReport from './data-compliance-issues/data-compliance-issues';
import CompositeScoreDashboard from './composite-score-dashboard';
import CenterSwapQualityIssues from './center-swap-quality-issues';
import LateBloodDraws from './late-blood-draws/late-blood-draws';

interface IProps {
    primaryKey: string,
    secondaryKey: string,
    tertiaryKey: string,
    report: string,
    center: ICenter
}

const CenterReports = (props: IProps) => {
    if (props.center == null)
        return null;

    return (
        <div style={{ padding: '0px 10px' }}>
            <CenterReportsNav
                tabKey={props.primaryKey}
                subTabKey={props.secondaryKey}
                report={props.report}
                center={props.center}
            />

            {props.secondaryKey == 'SUMMARY' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <DashboardSummary centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'PATIENT-DONORS' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <PatientDonors centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'VOLUME' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <DashboardVolume centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'CENTER-FIVE-STAR-SURVEYS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CenterFiveStarSurveyReport centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'NETWORK-FIVE-STAR-SURVEYS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <NetworkFiveStarSurveyReport centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'PWL' && props.center !== null && (
                <>
                    {props.report == 'LAB-BILLING' && (
                        <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                            <DashPWLLabBilling centerId={props.center.id} isAdmin={false} />
                        </div>
                    )}

                    {props.report == 'JUG-BILLING' && (
                        <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                            <DashPWLJugBilling centerId={props.center.id} isAdmin={false} />
                        </div>
                    )}
                </>
            )}

            {props.secondaryKey == 'COMPARISON' && props.center !== null && (
                <>
                    {props.report == 'CONVERSION' && (
                        <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                            <ComparisonConversionReport centerId={props.center.id} isAdmin={false} />
                        </div>
                    )}

                    {props.report == 'VOLUME' && (
                        <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                            <ComparisonVolumeReport centerId={props.center.id} isAdmin={false} />
                        </div>
                    )}

                </>
            )}

            {props.secondaryKey == 'CONTACTS' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <Contacts centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'COMPLIANCE' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <Compliance centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'DIRECTORY' && (
                <>
                    {props.report == 'ALL-CENTERS' && (
                        <div style={{ backgroundColor: '#FFF' }}>
                            <AllCenters centerId={props.center.id} isAdmin={false} />
                        </div>
                    )}

                    {props.report == 'CENTER-SPECIFIC' && (
                        <div style={{ backgroundColor: '#FFF' }}>
                            <CenterSpecifc centerId={props.center.id} />
                        </div>
                    )}
                </>
            )}

            {props.secondaryKey == 'CLC-DETAILS' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CenterCLCScoresReport centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'CLC-TARGETED-PAIRS' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CenterCLCTargetedPairsReport />
                </div>
            )}

            {props.secondaryKey == 'CLC-SCORING-GUIDE' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CenterCLCGuide />
                </div>
            )}

            {props.secondaryKey == 'CHAIN-END-DECLINE-RATIO' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <ChainEndDeclineRatio isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'NKR-DONOR-REFERRAL-CONVERSION-RATE' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <NkrDonorReferralConversionRate isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'CHAIN-END-OFFERS' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <ChainEndOffers isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'MISSED-MATCH-OFFERS' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <MissedMatchOffers centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'LATE-DONOR-REVIEWS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <LateDonorReviewsReport centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'REFR' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <RefrReport centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'LATE-SEROLOGIES' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <LateSerologies centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'SEROLOGY-FINAL-XM-BLOOD-DRAWS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <SerologyFinalXmBloodDraws centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'SEROLOGY-BLOOD-DRAWS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <SerologyBloodDraws centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'ON-TIME-KIDNEY-DETAIL' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <OnTimeKidneyPickupDetail centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'COLD-ISCHEMIA-LAG-TIME-DETAIL' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <ColdIschemiaLateDetail centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'PRESELECT-REVERSAL-DETAIL' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <PreselectReversalDetail centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'SURGICAL-DATE-DECLINES' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <SurgicalDateDeclines centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'OVERALL-PERFORMANCE' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <OverallPerformance isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'CLC-SCORE-DETAILS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CenterCLCScoresDetailsReport centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'PRESELECT-DETAILS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <PreselectHistoryDetail centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'PRESELECT-HISTORY' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <PreSelectHistoryByCenterReport centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'CENTER-CHAIN-END-OFFERS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CenterChainEndOffers centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'WAITLIST-AUDIT-REPORT' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <WaitlistAudit centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'FCR-SCORE-AUDIT-REPORT' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <FcrScoreAudit centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'CPR-SCORE-AUDIT-REPORT' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CprScoreAudit centerId={props.center.id} isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'LATE-VXM' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <LateVxm isCenterLogin={true} centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'BLOOD-DRAWS-OUTSIDE-WINDOW' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <LateBloodDraws isCenterLogin={true} centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'LATE-FINAL-XM' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <LateFinalXm isCenterLogin={true} centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'RCCAP' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <RccapList centerId={props.center.id} />
                </div>
            )}

            {props.secondaryKey == 'NCS' && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CenterNCSScoresReport isAdmin={false} />
                </div>
            )}

            {props.secondaryKey == 'TRANSPLANTED-PATIENTS' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <TransplantedPatients centerId={props.center.id} isCenterLogin={true} />
                </div>
            )}

            {props.secondaryKey == 'DATA-COMPLIANCE' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <DataComplianceIssuesReport centerId={props.center.id} />
                </div>
            )}

            {['NCS-SCORE', 'COMPOSITE-SCORE', 'TCE-FORMULA'].indexOf(props.secondaryKey) >= 0 && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CompositeScoreDashboard
                        activeKey={props.secondaryKey}
                        centerId={props.center.id}
                    />
                </div>
            )}

            {props.secondaryKey == 'SWAP-QUALITY-ISSUES' && props.center !== null && (
                <div style={{ padding: '5px 15px', backgroundColor: '#FFF' }}>
                    <CenterSwapQualityIssues centerId={props.center.id} />
                </div>
            )}
        </div>
    );
}

export default CenterReports;
